import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { MdOutlinePause, MdPlayArrow, MdClose } from "react-icons/md";

import ProgressIndicator from "./ProgressIndicator";

import { SetVPTStatus } from "../../../redux/v2/utils/actions";

function IndicatorController(props) {
    const navigate = useNavigate();
    const [status, setStatus] = useState("playing");
    const { controls, slidesProgress, speed, activeSlide, slideStarted, videoControls } = props;

    return (
        <div id="v-pt-indicator-controller">
            <div id="vp-t-ic-progress-bar-wrapper">
                {slidesProgress?.map((p, i) => {
                    return (
                        <ProgressIndicator slideStarted={slideStarted} controls={controls} width={100 / slidesProgress.length} slide={p} index={i} activeSlide={activeSlide} sliderStatus={status} setSlideStatus={setStatus} videoControls={videoControls} />
                        // <ProgressIndicator width={100 / progress.length} perc={(p.progress / p.max) * 100} />
                    );
                })}
            </div>
            {status === "playing" && (
                <MdOutlinePause
                    id="v-pt-s-pause"
                    onClick={() => {
                        setStatus("paused");
                        if (activeSlide == 0) {
                            videoControls?.pause();
                        }
                    }}
                />
            )}
            {status === "paused" && (
                <MdPlayArrow
                    id="v-pt-s-play"
                    onClick={() => {
                        setStatus("playing");
                        if (activeSlide == 0) {
                            videoControls?.play();
                        }
                    }}
                />
            )}

            <MdClose
                id="v-pt-s-close"
                onClick={() => {
                    navigate("/");
                    props.SetVPTStatus(null);
                }}
            />
        </div>
    );
}

const mapStateToProps = (state) => ({
});
export default connect(mapStateToProps, {
    SetVPTStatus,
})(IndicatorController);
